import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product, NewProduct, ProductSearchParams, PageableProducts } from '../domain/product.model';
import { ItemMovement } from '../domain/inventory.model';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private apiUrl = environment.apiUrl + '/api/v1/product';

  constructor(private http: HttpClient) { }

  searchProducts(params: ProductSearchParams): Observable<PageableProducts> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    return this.http.get<PageableProducts>(`${this.apiUrl}/search`, { params: httpParams });
  }

  createProduct(product: NewProduct): Observable<Product> {
    return this.http.post<Product>(this.apiUrl, product);
  }

  createVariant(parentProductId: number, product: NewProduct): Observable<Product> {
    return this.http.post<Product>(`${this.apiUrl}/${parentProductId}/variant`, product);
  }

  updateProduct(productId: number, product: Partial<NewProduct>): Observable<Product> {
    return this.http.put<Product>(`${this.apiUrl}/${productId}`, product);
  }

  getProductMovements(productId: number): Observable<ItemMovement[]> {
    return this.http.get<ItemMovement[]>(`${this.apiUrl}/${productId}/movements`);
  }

  getCategories(accountId: number, search?: string): Observable<string[]> {
    let params = new HttpParams().set('accountId', accountId.toString());
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<string[]>(`${this.apiUrl}/categories`, { params });
  }
}
